import React, { Component } from 'react';
import {RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import Toggle from 'material-ui/Toggle';
import { TextField, FontIcon } from 'material-ui';
import Chip from 'material-ui/Chip';


import ActionAndroid from 'material-ui/svg-icons/action/android';
import HardWarePhoneIphone from 'material-ui/svg-icons/hardware/phone-iphone';

import './css/AudienceForm.css';

const AndroidToggleLabel = () => (
    <span>
        <FontIcon color={styles.androidIcon.color} className="fab fa-android" />
        <span style={{ color: styles.androidIcon.color }}> Android</span> 
    </span>
)

const AppleToggleLabel = () => (
    <span>
        <FontIcon color={styles.iosIcon.color} className="fab fa-apple" /> 
        <span style={{ color: styles.iosIcon.color }}> iOS</span>
    </span>
);

class AudienceForm extends Component {
    constructor(){
        super();
        this.state = {
            topicType: '',
            topicPills: []
        }
        this.textClasses = ['textField'];
        this.textField = document.getElementsByClassName('textField');
    }

    componentDidMount(){
        this.textField[0].addEventListener('keypress', this.registerEnter)
    }

    componentWillUnmount(){
        this.textField[0].removeEventListener('keypress', this.registerEnter);
    }

    handleDeletePill = (text) => {
        this.setState((prevState) => {
            return {
                topicPills: prevState.topicPills.filter((item) => {
                    return item != text;
                })
            }
        })
    }

    handleRadio = (e, val) => {
        this.props.sendUp({type: val});

        if(this.textClasses.length > 1)
            this.textClasses.pop();

        if(val == 'TOPIC' && this.textClasses.length < 2)
            this.textClasses.push('expandText')

        this.forceUpdate();
    }

    handleTextChange = (e, val) => {
        this.setState({
            topicType: val
        })
    }

    handleToggle = (e, toggled, ref) => {
        if(ref == 'android')
            toggled ? styles.androidIcon.color = '#0079c2' : styles.androidIcon.color = 'gray';
        else
            toggled ? styles.iosIcon.color = '#0079c2' : styles.iosIcon.color = 'gray';
        this.forceUpdate();
    }

    renderPills = (arr) => {
        return arr.map((item, index) => {
            return (
                <Chip
                    onRequestDelete={function(){
                        console.log(this);
                        this.deletePill(this.children);
                    }}
                    className='topicPill'
                    labelColor={'white'}
                    deleteIconStyle={{color: 'white'}}
                    deletePill={this.handleDeletePill}
                    key={index}
                >
                    {item}
                </Chip>
            )
        })
        
    }

    registerEnter = (e) => {
        if(e.keyCode == 13){
            this.props.sendUp({topic: this.state.topicType})

            this.setState((prevState) => {
                return {
                    topicPills: [...prevState.topicPills, this.state.topicType],
                    topicType: '',
                }
            })
        }
    }
    
    render(){
        return(
            <div style={styles.container} className="audienceForm">
                <section style={{...styles.flexSection, flex: 2}}>
                    <h4>Target</h4>
                    <div style={{flex: 1}}>
                        <RadioButtonGroup 
                            name="shipSpeed" 
                            defaultSelected="ALL"
                            onChange={(e, val) => this.handleRadio(e, val)}
                        >
                            <RadioButton
                                value="ALL"
                                label="Send to All"
                                style={styles.radioToggle}
                            />
                            {/* <RadioButton
                                value="TOPIC"
                                label="Send to Tags"
                                style={styles.radioToggle}
                            /> */}
                        </RadioButtonGroup>
                        <TextField 
                            hintText={'Enter tag name'}
                            floatingLabelText={'Tag'}
                            className={this.textClasses.join(' ')}
                            ref='topicField'
                            value={this.state.topicType}
                            onChange={(e, text) => this.handleTextChange(e, text)}
                        />
                    </div>
                    <div style={{flex: 2, display: 'flex', alignItems: 'center'}}>

                    </div>
                </section>

                <section style={{...styles.flexSection, flex: 2, minHeight: '100px',  display: 'none'}}>
                    <h4>Tags</h4>
                    <div style={styles.pillContainer}>
                        {this.renderPills(this.state.topicPills)}
                    </div>
                </section>

                <section style={{...styles.flexSection, flexBasis: '100px', display: 'none'}}>
                    <h4>Platforms</h4>
                    <Toggle
                        label={<AndroidToggleLabel />}
                        style={styles.radioToggle}
                        onToggle={(e, toggled) => this.handleToggle(e, toggled, 'android')}
                    />

                    <Toggle
                        label={<AppleToggleLabel />}
                        style={styles.radioToggle}
                        onToggle={(e, toggled) => this.handleToggle(e, toggled, 'ios')}
                    />
                </section>
            </div>
        )
    }
}

export default AudienceForm;

const styles = {
    container: {
      display: 'flex',
      flexDirection: 'row',
      padding: '20px',
      alignItems: 'center',
      flexWrap: 'wrap'
    },
    radioToggle: {
        marginBottom: 16
    },
    flexSection: {
        flex: 1,
        display: 'flex',
        flexWrap: 'wrap',
        alignSelf: 'stretch',
        flexDirection: 'column',
        flexBasis: '250px',
    },
    toggleContainer: {
        flexDirection: 'column',
        alignItems: 'flex-end'
    },
    androidIcon: {
        color: 'gray',
    },
    iosIcon: {
        color: 'gray',
    },
    pillContainer:{
        display: 'flex',
        flexWrap: 'wrap',
    }
  }


// WEBPACK FOOTER //
// ./src/components/createEditPush/AudienceForm.js